<template>
  <v-container
    fluid
    class="dashboard-container py-6"
    :class="{
      'px-2': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm,
      'px-6': $vuetify.breakpoint.mdAndUp
    }"
  >
    <v-row dense align="stretch">
      <!-- CRÉDITO DISPONIBLE -->
      <v-col cols="12" md="4" class="d-flex">
        <v-card
          class="rounded-card flex-grow-1 d-flex flex-column justify-space-between"
          elevation="3"
          outlined
        >
          <h2
            class="primary--text text-center font-weight-black mt-4 mb-2"
            :class="{
              'text-h6': $vuetify.breakpoint.mdAndDown,
              'text-h5': $vuetify.breakpoint.lgAndUp
            }"
          >
            CRÉDITO DISPONIBLE
          </h2>

          <TilesGrid
            v-if="haveProducts && $store?.getters.user.client"
            :productTypes="$store?.getters.products"
            class="flex-grow-1"
            @onFinishLoading="setAuthorizedProducts"
          />
        </v-card>
      </v-col>

      <!-- MIS FACTURAS VENDIDAS -->
      <v-col cols="12" md="4" class="d-flex">
        <v-card
          elevation="3"
          class="rounded-card flex-grow-1 d-flex flex-column"
          outlined
        >
          <h2
            class="primary--text text-center font-weight-black mt-4 mb-2"
            :class="{
              'text-h6': $vuetify.breakpoint.mdAndDown,
              'text-h5': $vuetify.breakpoint.lgAndUp
            }"
          >
            MIS FACTURAS VENDIDAS
          </h2>

          <GraficoFactoraje
            ref="graficoFactoraje"
            v-if="haveProducts && $store?.getters.user.client"
            :productTypes="$store?.getters.products"
            :invoices="$store?.getters.invoices"
            class="flex-grow-1"
            @product-selected="handleChildProductSelected"
          />
        </v-card>
      </v-col>

      <!-- PAGOS A REALIZAR -->
      <v-col cols="12" md="4" class="d-flex">
        <v-card
          elevation="3"
          class="rounded-card flex-grow-1 d-flex flex-column"
          outlined
        >
          <h2
            class="primary--text text-uppercase text-center font-weight-black mt-4 mb-2"
            :class="{
              'text-h6': $vuetify.breakpoint.mdAndDown,
              'text-h5': $vuetify.breakpoint.lgAndUp
            }"
          >
            Pagos a realizar
          </h2>

          <v-card-text class="flex-grow-1 overflow-y-auto">
            <Payments
              v-if="haveProducts && $store?.getters.user.client"
              :invoices="$store?.getters.invoices.filter(invoice => invoice.status === invoiceStatus.CREDITO)"
            />

            <!-- Estado de cuenta -->
            <div class="text-center mt-4">
              <v-dialog v-model="dialog" max-width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    color="#5C9DF2"
                    class="font-weight-black white--text"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Consultar Estado De Cuenta
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title class="text-h5 grey lighten-2">
                    Consultar Estado de Cuenta
                  </v-card-title>

                  <v-card-text>
                    <v-select
                      v-model="productSelected"
                      :items="opcionesParaSelect"
                      item-text="name"
                      item-value="creditLineId"
                      label="Selecciona un producto"
                      return-object
                      outlined
                      dense
                      class="mb-3"
                    />

                    <v-expand-transition>
                      <div v-if="productSelected">
                        <p class="text-h6 grey lighten-2 px-2 py-1 mb-2">Seleccionar mes:</p>
                        <v-date-picker
                          type="month"
                          v-model="month"
                          :min="minDate"
                          :max="currentDate"
                          locale="es"
                          full-width
                        />
                      </div>
                    </v-expand-transition>
                  </v-card-text>

                  <v-divider />

                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="#5C9DF2"
                      class="font-weight-black white--text"
                      :disabled="month === null"
                      @click="saveDateAndCreatePdf"
                    >
                      Descargar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>

            <!-- Generar referencia -->
            <div class="text-center mt-4">
              <v-btn
                block
                color="#5C9DF2"
                class="font-weight-black white--text"
                @click="handleGenerateReference"
              >
                Generar referencia de pago
              </v-btn>
            </div>
            <v-dialog v-model="modal" scrollable width="100%">
              <InvoiceTable
                v-if="modal"
                @generated="onPaymentGeneration"
                @onClose="close"
                :statusFilter="statusFilter"
                :productFilter="productFilter"
                :productTypes="$store.getters.products"
                :costCenters="costCenters"
              />
            </v-dialog>
            <v-dialog persistent v-model="referenceModal" scrollable :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '100%' : '55%'">
              <PaymentReference
                :key="paymentReferenceKey"
                @onClose="close"
                :paymentReference="paymentReference"
                :referenceId="referenceId"
              />
            </v-dialog>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Encuesta -->
    <v-dialog scrollable max-width="900" v-model="modalSurvey" persistent>
      <Survey
        ref="Survey"
        :key="SurveyKey"
        :surveyQuestions="$store?.getters.survey.questions"
        :surveyTitle="$store?.getters.survey.title"
        @onClose="onCloseSurvey"
      />
    </v-dialog>
  </v-container>
</template>

<script>
// import StpService from '@/services/StpService'
import CreditsManagerService from '@/services/CreditsManagerService'
import FactoringDocumentService from '@/services/FactoringDocumentService'
import TilesGrid from '@/components/TilesGrid'
import GraficoFactoraje from '@/components/GraficoFactoraje'
import Survey from '@/components/Survey'
import Payments from '@/components/Payments'
import PaymentReference from '@/components/PaymentReference'
import Utils from '@/common/utils'
import Status from '@/common/FactoringDocumentStatus'
import InvoiceTable from '@/components/InvoiceTable'
import moment from 'moment'
moment.locale('es')

export default {
  name: 'Dashboard',
  components: {
    TilesGrid,
    GraficoFactoraje,
    Payments,
    Survey,
    InvoiceTable,
    PaymentReference
  },
  data () {
    return {
      haveProducts: false,
      modalSurvey: false,
      SurveyKey: 0,
      invoiceStatus: Status,
      dialog: false,
      month: null,
      productSelected: null,
      currentDate: moment().format('YYYY-MM'),
      minDate: process.env.VUE_APP_MIN_DATE_BANK_STATEMENT,
      modal: false,
      paymentReference: null,
      paymentReferenceKey: 0,
      referenceId: null,
      referenceModal: false,
      statusFilter: Status.CREDITO,
      productFilter: null,
      costCenters: [],
      statusIndex: {},
      productBIactivated: false,
      productFBactivated: false
    }
  },

  async beforeMount () {
    const isLoggedIn = this.$store?.getters?.isLoggedIn

    if (!isLoggedIn) {
      window.location.replace('/login')
      return
    }

    await this.getProducts()
  },

  mounted () {
    var self = this
    setTimeout(function () {
      if (self.$store?.getters.survey && self.$store?.getters.survey.questions && self.$store?.getters.survey.questions.length) {
        self.SurveyKey += 1
        self.modalSurvey = true
      }
    }, 4000)
    this.watchSurvey()
  },

  methods: {
    async getProducts () {
      await this.$store?.dispatch('setProducts')
      this.haveProducts = !Utils.isObjectEmpty(this.$store?.getters.products)
    },

    setAuthorizedProducts () {
      this.$refs?.grafico?.setInitialProduct()
    },

    async watchSurvey () {
      setInterval(async () => {
        if (!this.modalSurvey) {
          await this.$store?.dispatch('survey')
          if (self.$store?.getters.survey && self.$store?.getters.survey.questions && this.$store?.getters.survey.questions.length) {
            this.SurveyKey += 1
            this.modalSurvey = true
          }
        }
      }, 320000) // 10000)
    },

    onCloseSurvey () {
      this.modalSurvey = false
      this.$swal('Datos guardados', this.$store?.getters.survey.finishMessage ? this.$store?.getters.survey.finishMessage : '¡Gracias por tu tiempo!', 'success')
    },

    async saveDateAndCreatePdf () {
      const params = {
        body: { dateSelected: this.month },
        creditLineId: this.productSelected.creditLineId
      }
      const loader = this.$loading.show()
      const pdfName = this.generatePdfName(this.month, this.productSelected.name)
      const data = await CreditsManagerService.getFactoringDispersionsPdf(params)
      await this.createPDF(data, pdfName)
      this.closeModal(loader)
    },

    async createPDF (data, pdfName) {
      try {
        const blob = Utils.converBase64toBlob(data.base64, 'application/pdf')
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = pdfName
        link.click()
      } catch (error) {
        this.$swal('¡Error!', 'No se pudo generar el documento, contacta al administrador', 'error')
      }
    },

    closeModal (loader) {
      this.dialog = false
      this.month = null
      this.productSelected = null
      loader.hide()
    },

    generatePdfName (month, product) {
      return `${product.split(' ').join('_')}_${month.split('-').join('_')}`
    },

    onPaymentGeneration (reference) {
      this.modal = false
      this.paymentReference = reference.paymentReference
      this.referenceId = reference.referenceId
      this.paymentReferenceKey += 1
      this.referenceModal = true
    },

    close () {
      this.referenceModal = false
      this.modal = false
    },

    async handleGenerateReference () {
      const loader = this.$loading.show()
      this.setProductFilter()
      switch (this.statusIndex.CREDITO) {
      case this.statusIndex.CREDITO:
        this.statusFilter = Status.CREDITO
        try {
          const { data } = await FactoringDocumentService.getDocuments({
            clientId: this.$store?.getters.user.clientId,
            products: [this.productFilter],
            status: [Status.CREDITO],
            withoutPaymentDate: true
          })
          await this.$store?.dispatch('updateCreditInvoices', data)
        } catch (error) {
          console.info(error)
        }
        // try {
        //   const data = await StpService.getPayerCostCenterByClient(this.$store?.getters.user.client.rfc || '')
        //   this.costCenters = data
        // } catch (error) {
        //   this.costCenters = []
        //   console.error(error)
        // }
        break
      case this.statusIndex.RECHAZADA:
        this.statusFilter = Status.RECHAZADA
        break
      case this.statusIndex.PREVENTA:
        this.statusFilter = Status.PREVENTA
        break
      default:
        this.statusFilter = Status.CREDITO
        break
      }
      await this.getInvoices()
      if (this.productFilter === this.$store?.getters.products.BI.productId) this.modal = true
      loader.hide()
    },

    setProductFilter () {
      if (this.productBIactivated) {
        this.productFilter = this.$store?.getters.products.BI.productId
      }
      if (!this.productBIactivated && !this.productFBactivated) {
        if (this.isAuthBI) {
          this.productFilter = this.$store?.getters.products.BI.productId
        }
      }
    },

    async getInvoices (productId = null) {
      let products = [productId]
      if (!productId) {
        products = [this.$store?.getters.products.BI.productId, this.$store?.getters.products.FB.productId]
      }

      try {
        const { data } = await FactoringDocumentService.getDocuments({
          clientId: this.$store?.getters.user.clientId,
          products,
          status: [
            Status.RECHAZADA,
            Status.PREVENTA,
            Status.CREDITO
          ],
          sevenDaysRejectedDate: true
        })

        const rejected = data.filter(item => item.status === Status.RECHAZADA)
        await this.$store?.dispatch('updateInvoicesByStatus', {
          invoices: rejected,
          status: Status.RECHAZADA
        })

        const presell = data.filter(item => item.status === Status.PREVENTA)
        await this.$store?.dispatch('updateInvoicesByStatus', {
          invoices: presell,
          status: Status.PREVENTA
        })

        const credit = data.filter(item => item.status === Status.CREDITO)
        await this.$store?.dispatch('updateInvoicesByStatus', {
          invoices: credit,
          status: Status.CREDITO
        })
      } catch (error) {
        console.error(error)
      }
    },

    handleChildProductSelected (productChildSelected) {
      this.productBIactivated = productChildSelected.productBI
      this.productFBactivated = productChildSelected.productFB
    }

  },

  computed: {
    isProductionOrDev () {
      return (process.env.VUE_APP_BLUENV === 'production' || process.env.VUE_APP_BLUENV === 'development')
    },

    opcionesParaSelect () {
      const items = []
      for (const item of this.$store?.getters.creditsInformation) {
        const i = this.$store?.getters.products[item.product]
        items.push({ ...item, name: i.displayName })
      }
      return items
    },

    isAuthBI () {
      return this.$store?.getters.isAuthBI
    },

    isAuthFB () {
      return this.$store?.getters.isAuthFB
    }
  }
}
</script>
<style scooped>
.rounded-card {
  border-radius: 16px !important;
  overflow: hidden;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.rounded-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.v-row.align-stretch > .v-col {
  display: flex;
}

.font-weight-black {
  font-weight: 900 !important;
}

h2 {
  line-height: 1.2;
  word-break: keep-all;
}

.v-container {
  box-sizing: border-box;
}

.dashboard-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: calc(95vh - 80px);
  overflow: hidden;
}

@media (max-width: 960px) {
  .v-container {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
}

@media (min-width: 961px) {
  .v-container {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }
}

.v-btn:hover {
  filter: brightness(1.05);
}

.v-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.overflow-y-auto {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}
</style>
